<template>
  <div>
    <div class="prompt">
      <span class="prompt-text"></span>
      <div class="hint-text" v-html="text"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "No description.",
    },
  },
};
</script>

<style scoped>
.prompt-text {
  font-family: "EBI-Common";
}
</style>